import React from "react";
import { Box, Typography } from "@mui/material";
import { getPriceLabel, getProductCompareAtPrice } from "../utils/productAdapter";

/** Precio vigente + referencia anterior opcional. Nunca modifica valores de compra. */
export default function ProductPriceDisplay({
  product, money, variant = null, quantity = 1, color = "inherit", variantSize = "h5", sx = {},
}) {
  const previous = getProductCompareAtPrice(product, variant, quantity);
  return (
    <Box sx={{ minWidth: 0, ...sx }}>
      {previous !== null ? (
        <Typography component="div" variant="body2" sx={{ mb: 0.3, color: "text.secondary", fontWeight: 500, lineHeight: 1.45, overflowWrap: "anywhere" }}>
          <Box component="span" sx={{ mr: 0.65 }}>Antes</Box>
          <Box component="del" sx={{ textDecorationThickness: "1.4px", textDecorationColor: "currentColor" }}>{money(previous)}</Box>
        </Typography>
      ) : null}
      <Typography component="div" variant={variantSize} sx={{ fontWeight: 850, lineHeight: 1.18, letterSpacing: "-.025em", color, overflowWrap: "anywhere", fontVariantNumeric: "tabular-nums" }}>
        {getPriceLabel(product, money, variant, quantity)}
      </Typography>
    </Box>
  );
}
